import axios from 'axios';
import actions from './actions';
import config from '../../../../config/index';

const getBankVerificationInitialDataAction = actions.Creators.getBankVerificationInitialData;

const getBankVerificationInitialData = (accountUuid) => async dispatch => {
    try {
        const response = await axios.get(config.apiUrl + '/fundingPlatformPublic/bankVerification/getInitialDatabyAcc/' + accountUuid);
        let account = response.data.account;
         account.link_token = response.data.plaidToken.link_token;
        dispatch(getBankVerificationInitialDataAction({account,accountUuid}));
    }
    catch (error) {
        dispatch(error);
    }
    return;
}

const getTransactions = async (token, metadata) => {
    try {
        await axios.post(config.apiUrl + '/fundingPlatformPublic/bankVerification/getTransactions', { token: token, metadata: metadata });
    }
    catch (error) {
        console.error(error);
    }
    return;
}

const getBankData = async (linkedBanks, accountUuid) => {
    let linkedBanksArray = linkedBanks.map(linkedBank => {
        return { publicToken: linkedBank.token, institutionName: linkedBank.metadata.institution.name };
    });
    try {
        await axios.post(config.apiUrl + '/fundingPlatformPublic/bankVerification/getBankData', { linkedBanks: linkedBanksArray, accountUuid});
    }
    catch (error) {
        console.error(error);
    }
    return;
}

export default {
    getBankVerificationInitialData,
    getTransactions,
    getBankData
}